<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="80px" @submit.native.prevent style="max-width: 1030px;">
      <el-form-item label="姓名">
        <el-input v-model="form.Profile.Name"></el-input>
      </el-form-item>
      <el-form-item label="Email帳號">
        <el-input v-model="form.Username"></el-input>
      </el-form-item>
      <el-form-item label="密碼">
        <el-input v-model="form.Password" type="password"></el-input>
      </el-form-item>
      <el-form-item label="確認密碼">
        <el-input v-model="form.ConfirmPassword" type="password"></el-input>
      </el-form-item>
      <el-form-item label="階級">
        <el-select v-model="form.AdminLevel" placeholder="請選擇">
          <el-option :value="0" label="一般會員"></el-option>
          <el-option :value="10" label="部落客"></el-option>
          <el-option :value="100" label="會計"></el-option>
          <el-option :value="1000" label="管理員"></el-option>
          <el-option :value="10000" label="最高管理員"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="form.AdminLevel==10" label="ID">
        <el-input v-model="form.Profile.URLKey"></el-input>
        <p class="hint">部落客專屬ID，用於團購網址。ex: /team-buying/XXXXX-XXXXX</p>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
        AdminLevel: 0,
        Username: '',
        Profile: { Name: '' }
      },
      mIsShow: false,
      isLoading: false
    }
  },
  computed: {
    isEdit () {
      return false
    },
    title () {
      return '新增管理員'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      let payload = JSON.parse(JSON.stringify(this.form))
      if (this.isEdit) throw String('unexpected edit user in [modal-editor-profile]')
      let promise = this.isEdit
        ? this.$services.user.edit(this, this.userID, { user: payload })
        : this.$services.user.add(this, { user: payload })
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res, payload)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res, payload) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = { Profile: {} }
      this.$emit('submitted')
      this.close()
    },
    loadResult (res) {
      // var newObj = JSON.parse(JSON.stringify(this.form))
      // if (!this.isEdit) {
      //   this.$store.state.user.list.splice(0, 0, newObj)
      // }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.Password) {
        errMsg = '請輸入密碼'
      } else if (this.form.Password != this.form.ConfirmPassword) {
        errMsg = '兩次密碼輸入不同'
      }
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          // this.form = JSON.parse(JSON.stringify(this.oriObj))
        } else {
          this.form = {
            AdminLevel: 0,
            Username: '',
            Profile: { Name: '' }
          }
        }
      }
    }
  }
}
</script>
